export default {
  name: 'RtTree',
  render(h) {
    return h(
      'el-tree',
      {
        attrs: this.$attrs,
        props: this.$props,
        ref: 'tree'
      },
      this.$slots.default
    );
  },
  methods: {
    filter(val) {
      this.$refs.tree.filter(val);
    }
  }
};



// WEBPACK FOOTER //
// ./~/vue-xpc/src/components/tree/rtTree.js